import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';
import LoadingAnimation from '../../common/loading/components/LoadingAnimation';

export default createLoadableComponent(() => import('./components/ContactUsOrderList'), {
  FallbackComponent: LoadingAnimation,
});
